import { BackgroundCheckConfig } from '@/backend/features/background-check/defaults';
import { BackgroundCheckType } from '@/backend/features/background-check/types';

export const getEnabledBackgroundCheckTypes = (backgroundCheckConfig?: BackgroundCheckConfig): BackgroundCheckType[] =>
    backgroundCheckConfig?.type
        ? Object.entries(backgroundCheckConfig?.type).reduce((acc, [type, value]) => {
              if (value.enabled) {
                  acc.push(type as BackgroundCheckType);
              }

              return acc;
          }, [] as BackgroundCheckType[])
        : [];
